import { useOfferingType } from '@/hooks/useOfferingType';
import { ProductOffering } from './TheOffering.product';
import { ServiceOffering } from './TheOffering.service';
import { MixedOffering } from './TheOffering.mixed';

/**
 * Thin router that delegates to the correct offering view
 * based on the selected site's offering_type.
 *
 * - 'product' (default) -> ProductOffering  (original 4,500-line component)
 * - 'service'           -> ServiceOffering  (new service-oriented view)
 * - 'mixed'             -> MixedOffering    (both stacked)
 */
export default function TheOffering() {
  const offeringType = useOfferingType();

  switch (offeringType) {
    case 'service':
      return <ServiceOffering />;
    case 'mixed':
      return <MixedOffering />;
    case 'product':
    default:
      return <ProductOffering />;
  }
}
